import { blankToNull } from '../../../utils'

export function validate(record) {
  const errors = []
  
  if (!record.chavePublica) {
    errors.push({
      field: 'chavePublica',
      message: 'Chave pública é obrigatória',
    })
  }

  if (!record.chavePrivada) {
    errors.push({
      field: 'chavePrivada',
      message: 'Chave privada é obrigatória',
    })
  }

  blankToNull(record)
  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }
  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
